import { configureIguazuRPC, setProcedures } from 'iguazu-rpc';
import readCustomerProductsV2 from '../product-ducks/readCustomerProductsV2';
import readCustomerProductDetailsV1 from '../product-ducks/readCustomerProductDetailsV1';

const configureIguazuProcedures = () => {
  configureIguazuRPC({
    getToState: (state) => state.getIn(['modules', 'axp-document-communications-root', 'procedures']),
  });

  setProcedures({
    readCustomerProductsV2,
    readCustomerProductDetailsV1,
  });
};
configureIguazuProcedures();

export default configureIguazuProcedures;
